import { render, staticRenderFns } from "./Honored.vue?vue&type=template&id=6a127f9e&scoped=true&"
import script from "./Honored.vue?vue&type=script&lang=js&"
export * from "./Honored.vue?vue&type=script&lang=js&"
import style0 from "./Honored.vue?vue&type=style&index=0&id=6a127f9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a127f9e",
  null
  
)

export default component.exports